<template>
    <div id="text-message">
        <span style="padding-left: 5px" v-html="textContent"></span>
        <button v-if="side==='admin'" class="status-btn status-btn-text-type">
            <i v-if="currentStatus==='sent'" class="fa fa-check" aria-hidden="true"></i>
            <i v-else-if="currentStatus==='send'" class="fa fa-spinner loading" aria-hidden="true"></i>
            <i v-else class="fa fa-warning" aria-hidden="true"></i>
        </button>
    </div>
    <div   v-bind:class="{ 'expert-comment-time' : side==='admin' , 'user-comment-time' : side==='user' }">
        <span>
           {{createdAt}}
               <span v-if="side==='admin'" class="sender-details">
                    /
               <span v-if="relatedAdmin.role === 'Deputy'">
                   معاون
               </span>
               <span v-else-if="relatedAdmin.role === 'DepartmentHead'">
                   مدیر گروه
               </span>
               <span v-else-if="relatedAdmin.role === 'GeneralManager'">
                   مدیر دپارتمان
               </span>
               <span v-else-if="relatedAdmin.role === 'Expert'">
               <span v-if="relatedAdmin.type === 'Expert_Client'">
                   کارشناس اصلی
               </span>
               <span v-else-if="relatedAdmin.type === 'AlongExpert_Client'">
                  کارشناس همراه
               </span>
               <span v-else>
                   کارشناس
               </span>
               </span>
               <span v-else>
                  مدیر کل
               </span>
            </span>
        </span>
        <button class="status-btn" v-if="side==='user'">
             <span v-if="currentStatus==='sent'">
                 <span class="iconify" data-icon="bi:check" data-inline="false"></span>
             </span>
            <span class="loading" v-else-if="currentStatus==='send'">
             <span class="iconify" data-icon="uil:spinner-alt" data-inline="false"></span>
            </span>
            <span v-else>
                 <span class="iconify" data-icon="ant-design:warning-outlined" data-inline="false"></span>
            </span>
        </button>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "TextMessage",
        data(){return {currentStatus:'sent'}},
        props: {
            currentUserDetails:Object,
            status: String,
            submitKey: Number,
            textContent:String,
            side:String,
            currentDate: String,
            createdAt: String,
            relatedAdmin:Object
        },
        methods:
            {
                upload() {
                    this.currentStatus = this.status;
                    axios.post('/api/userDashboard/chatTextStore',
                        {
                            data: {
                                text: this.textContent
                            }
                        }, {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        }).then(response => {
                        this.currentStatus = 'sent';
                        this.messages = response.data.results
                    }).catch(error => {
                        this.currentStatus = 'error';
                        console.log(error);
                    });
                },
    },
        mounted() {
            let localStorageCurrentDate = localStorage.getItem('currentDate');
            if(this.currentDate === localStorageCurrentDate){
                this.upload();
            }
        }
    }
</script>

<style lang="scss" scoped>
    #text-message{
        padding: 0;
    }
    .expert-comment-time,.user-comment-time{
        display: flex !important;
        opacity: 0.5;
        font-family: IRANSans;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: right;
        color: #000000;
        width: 100%;
        height: 30px;
        line-height: 30px;
    }
    .user-comment-time{
        justify-content: flex-end;
    }
    .expert-comment-time{

    }
    .action-btn{
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        cursor: pointer;
        background: transparent;
        color: black;
        margin:0;
        span{
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .status-btn{
        background: transparent;
        color: black;
        margin:0;
        span{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;
        }
    }

    .loading{
        -webkit-animation:spin 1s linear infinite;
        -moz-animation:spin 1s linear infinite;
        animation:spin 1s linear infinite;
    }
    @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

</style>